import { getRequestEvent, query } from '$app/server';
import {
	readItem,
	readItems,
	type CollectionType,
	type Query,
	type QueryItem,
	type ReadItemOutput,
	type RegularCollections
} from '@directus/sdk';
import getDirectusInstance from './directus.js';
import type { Schema } from '../schema.js';

export const directusReadItems = query(
	'unchecked',
	<
		Collection extends RegularCollections<Schema>,
		const TQuery extends Query<Schema, CollectionType<Schema, Collection>>,
		Output = ReadItemOutput<Schema, Collection, TQuery>[]
	>({
		collection,
		query
	}: {
		collection: Collection;
		query?: TQuery;
	}) => {
		return getDirectusInstance(getRequestEvent().fetch).request<Output>(
			readItems(collection, query)
		);
	}
);

export const directusReadItem = query(
	'unchecked',
	<
		Collection extends RegularCollections<Schema>,
		const TQuery extends QueryItem<Schema, CollectionType<Schema, Collection>>,
		Output = ReadItemOutput<Schema, Collection, TQuery>
	>({
		collection,
		key,
		query
	}: {
		collection: Collection;
		key: string | number;
		query?: TQuery;
	}) => {
		return getDirectusInstance(getRequestEvent().fetch).request<Output>(
			readItem(collection, key, query)
		);
	}
);
